import { FileTextIcon, ReceiptIcon, ScrollTextIcon } from 'lucide-react';

import type { BillDTO } from '@invenco/accounts-interface';

import { Button } from '@/components/core/button';
import { DetailList } from '@/components/detail-list';
import { StatusBadge } from '@/components/status-badge';
import { formatMoney } from '@/shared/helpers';
import { invoiceStatusType } from '@/shared/status-maps';
import { invoiceStatusTitle } from '@/shared/title-maps';

export function InvoiceSection({ bill, isLoading }: { bill?: BillDTO; isLoading: boolean }) {
  const invoice = bill?.invoice;

  if (!invoice) {
    return null;
  }

  return (
    <DetailList
      title="Invoice"
      isLoading={isLoading}
      items={[
        {
          icon: FileTextIcon,
          label: 'Name',
          value: invoice.externalUrl ? (
            <Button variant="link" size="inline" asChild>
              <a href={invoice.externalUrl} target="_blank" rel="noreferrer">
                {invoice.name ?? bill?.invoiceName}
              </a>
            </Button>
          ) : (
            (invoice.name ?? bill?.invoiceName)
          ),
        },
        {
          icon: ReceiptIcon,
          label: 'Total',
          value: formatMoney(invoice.totalAmount ?? 0),
        },
        {
          icon: ScrollTextIcon,
          label: 'Status',
          value: (
            <StatusBadge
              status={invoice.status}
              type={invoiceStatusType}
              title={invoiceStatusTitle}
            />
          ),
        },
      ]}
    />
  );
}
